// 1. jQuery primeiro
import $ from 'jquery';

// 2. jQuery Migrate para funcionalidades deprecated
import 'jquery-migrate';

// 3. Expor globalmente antes dos plugins
window.$ = window.jQuery = $;

// 4. Bootstrap (depende do jQuery)
import 'bootstrap-sass/assets/javascripts/bootstrap';

// 5. AdminLTE (depende do jQuery e Bootstrap)
import 'admin-lte/dist/js/adminlte.min.js';

// 6. Outras bibliotecas
import 'sweetalert';
